import { baseApi, API_TAGS, createCacheTags, createEndpointBuilder, type Params } from '@/shared/api';

import type { DispatchInProgressInfiniteQueryArgs, DispatchInProgressPageResponse } from '../model/in-progress-types';

const dispatchEndpoint = createEndpointBuilder('/api/v2/dispatch');

/**
 * In-progress dispatches list endpoint (`GET /api/v2/dispatch/in-progress`):
 * journeys dispatched from the active site that have not been received
 * anywhere yet. Same paging/sorting shape as the receive history slice.
 */
export const dispatchInProgressApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDispatchInProgress: builder.infiniteQuery<
      DispatchInProgressPageResponse,
      DispatchInProgressInfiniteQueryArgs,
      number
    >({
      infiniteQueryOptions: {
        initialPageParam: 0,
        getNextPageParam: (lastPage, _allPages, lastPageParam) => {
          const nextPage = lastPageParam + 1;
          if (nextPage >= lastPage.totalPages) {
            return undefined;
          }
          return nextPage;
        }
      },
      query: ({ queryArg, pageParam }) => ({
        url: dispatchEndpoint('/in-progress'),
        params: {
          ...queryArg,
          page: pageParam
        }
      }),
      providesTags: (_result, _error, { queryArg }) =>
        createCacheTags({
          baseTag: API_TAGS.DISPATCH,
          params: queryArg as unknown as Params
        })
    })
  })
});

export const { useGetDispatchInProgressInfiniteQuery } = dispatchInProgressApi;
